export default __webpack_public_path__ + "icons/favicon-32x32-78b38af6e5ded8497b50f884e75092e3.png";